import moment from 'moment';

/**
 * Generates a meaningful filename for PDF receipts
 * @param {Object} order - The order object containing order details
 * @returns {string} - Formatted filename for the PDF
 */
export const generatePdfFilename = order => {
  if (!order) {
    return 'receipt';
  }

  const { id, user, event } = order;

  // Sanitize text for filename (remove special characters)
  const sanitizeText = text => {
    if (!text) return '';
    return text.replace(/[^a-zA-Z0-9\s-_]/g, '').replace(/\s+/g, '_');
  };

  // Build filename components
  const orderId = id ? `order_${id}` : 'order';
  const userName = user ? sanitizeText(`${user.firstName || ''}_${user.lastName || ''}`.trim()) : '';
  const eventName = event ? sanitizeText(event.name) : '';
  const date = moment().format('YYYY_MM_DD');

  // Create filename parts array and filter out empty values
  const filenameParts = ['receipt', orderId, userName, eventName, date].filter(part => part && part !== '_');

  // Join parts with underscores and ensure it's not too long
  let filename = filenameParts.join('_');

  // Truncate if too long (keeping it under 100 characters for compatibility)
  if (filename.length > 100) {
    filename = filename.substring(0, 100);
  }

  return filename;
};
